module.exports = __webpack_public_path__ + "static/media/performanceLeader_feature@2x.e04741c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/performanceLeader/performanceLeader_feature@2x.png
// module id = 61
// module chunks = 0